import analytics from 'lib/client/analytics/analytics';

export enum StepLabel {
  Step1Reason = '1Reason',
  EmailVerificationEnterEmail = 'EmailVerificationEnterEmail',
  EmailVerificationEnterCode = 'EmailVerificationEnterCode',
  Step2ReportedContentAllUsers = '2ReportedContentAllUsers',
  Step2ReportedContentSpotifyEmployees = '2ReportedContentSpotifyEmployees',
  Step3ThankYou = '3ThankYou',
}

class PolicyReportingAnalyticsUtils {
  trackVirtualPageView = (pathname: string, search: string, step: StepLabel) => {
    const queryParams = search ? `${search}&step=${step}` : `?step=${step}`;
    analytics.trackPageView(`${pathname}${queryParams}`);
  };
}

export default new PolicyReportingAnalyticsUtils();
